import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import AutomativeLaminatedGlassBanner from "../../../Assets/Product_Images/AutomativeLaminatedGlass/AutomativeLaminatedGlassBanner.webp";
import AutomativeLaminatedGlass1 from "../../../Assets/Product_Images/AutomativeLaminatedGlass/AutomativeLaminatedGlass1.jpeg";
import AutomativeLaminatedGlass2 from "../../../Assets/Product_Images/AutomativeLaminatedGlass/AutomativeLaminatedGlass2.jpeg";
import AutomativeLaminatedGlass3 from "../../../Assets/Product_Images/AutomativeLaminatedGlass/AutomativeLaminatedGlass3.jpeg";
import AutomativeLaminatedGlass4 from "../../../Assets/Product_Images/AutomativeLaminatedGlass/AutomativeLaminatedGlass4.jpeg";
import AutomativeLaminatedGlass5 from "../../../Assets/Product_Images/AutomativeLaminatedGlass/AutomativeLaminatedGlass5.jpeg";

import { Link } from "react-router-dom";

const Automative_Laminated_Glass = () => {
  return (
    <div>
      <Header />
      {/* banner section start  */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${AutomativeLaminatedGlassBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h2>
                  <Link
                    to="/AboutUs"
                    className="text-decoration-none text-white"
                  >
                    ABOUT US
                  </Link>{" "}
                  / <span className="text-white">Automotive Laminated Glass</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end */}

      {/* about tabbing section start  */}
      <section className="container-fluid about_Products_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="blog_text wow fadeInUp">
                <h5
                  style={{
                    color: "#153fa4",
                    fontFamily: "Segoe UI, sans-serif",
                    fontSize: "40px",
                    fontWeight: "700",
                    marginBottom: "15px",
                  }}
                >
                  Automotive Laminated Glass
                </h5>
                <p>
                  Usually polyvinyl butyral (PVB), the interlayer bonding two or
                  more layers of glass in automotive laminated glass serves to
                  keep the glass together upon collision. Mostly used in
                  windshields to guarantee visibility and passenger safety
                  during crashes, it is the glass that stays mostly intact even
                  when fractured, hence preventing shards from inflicting
                  damage.
                </p>
                <p>
                  Laminated glass is essential for automobile safety since it
                  greatly lowers the risk of ejection from the car on crash. It
                  is great for improved security since it provides better
                  resistance to penetration and sound insulation. Additionally
                  enhancing comfort and efficiency, laminated glass can be
                  embedded with acoustic or solar control layers.
                </p>
                <p>
                  Particularly in models that emphasize noise reduction and
                  theft protection, premium automobiles use this glass also for
                  side and rear windows. Particularly in cars with advanced
                  driver-assistance systems (ADAS), laminated glass's longevity
                  and safety characteristics have made it a norm in several
                  safety laws globally.
                </p>

                <p>
                  <strong>Key Features:</strong>
                </p>
                <ul>
                  <li>Break and crack resistance</li>
                  <li>High durability under stress</li>
                  <li>Smooth, optimum finish</li>
                </ul>
              </div>
              <div className="Products_img gap-5 mt-5 wow fadeInUp">
                <img src={AutomativeLaminatedGlass1} style={{width : "180px" , height : "180px"}} alt="Bus" />
                <img src={AutomativeLaminatedGlass2} style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={AutomativeLaminatedGlass3} style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={AutomativeLaminatedGlass4} style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={AutomativeLaminatedGlass5} style={{width : "180px" , height : "180px"}} alt="car" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about tabbing section End */}

      <Footer />
    </div>
  );
};

export default Automative_Laminated_Glass;
